module.exports = __webpack_public_path__ + "static/media/close-dark.23a0d5dc.svg";